module.exports = __webpack_public_path__ + "static/media/new icon for humza-11.37afb2ba.svg";